import { MatDialogConfig } from '@angular/material/dialog';
import { CreatePurchaseNoteDialogData } from './create-purchase-note.component';

export const CREATE_PURCHASE_NOTE_PANEL_CLASS = 'create-order-panel';

export function buildCreatePurchaseNoteDialogConfig(
  data: CreatePurchaseNoteDialogData,
  options?: { disableClose?: boolean }
): MatDialogConfig<CreatePurchaseNoteDialogData> {
  return {
    width: '520px',
    maxWidth: '94vw',
    panelClass: CREATE_PURCHASE_NOTE_PANEL_CLASS,
    autoFocus: false,
    disableClose: options?.disableClose ?? false,
    data
  };
}
